import React from "react"

function IconHeart({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="heart"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-heart"
      {...props}
    >
      <path
        d="M8.074 4.9A4.47 4.47 0 0 0 4.83 6.305c-1.774 1.857-1.773 4.835 0 6.694l6.522 6.847a.812.812 0 0 0 1.187-.007l6.52-6.833c1.776-1.857 1.776-4.837 0-6.694l-.165-.165a4.454 4.454 0 0 0-6.329.165l-.619.641-.621-.648A4.484 4.484 0 0 0 8.075 4.9zm0 1.2c.887 0 1.741.362 2.384 1.034l1.486 1.552 1.487-1.543a3.257 3.257 0 0 1 4.761-.002c1.332 1.393 1.332 3.643 0 5.036l-6.25 6.549-6.243-6.555c-1.332-1.395-1.332-3.644 0-5.037A3.27 3.27 0 0 1 8.073 6.1z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconHeart
